'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

interface QueryProviderProps {
  children: React.ReactNode;
}

export default function ReactQueryProvider({ children }: QueryProviderProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60, // 1 minute
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return <QueryClientProvider data-component-id="src/providers/react-query.tsx:24:9" data-component-path="src/providers/react-query.tsx" data-component-line="24" data-component-end-line="24" data-component-file="react-query.tsx" data-component-name="QueryClientProvider" data-component-content="%7B%22elementName%22%3A%22QueryClientProvider%22%7D" client={queryClient}>{children}</QueryClientProvider>;
}
